export const SET_PAGES = 'SET_PAGES'
export const NEXT_PAGE = 'NEXT_PAGE'
export const PREV_PAGE = 'PREV_PAGE'
export const FIRST_PAGE = 'FIRST_PAGE'
export const LAST_PAGE = 'LAST_PAGE'
export const GOTO_PAGE = 'GOTO_PAGE'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_POST_LOGIN_PAGE = 'SET_POST_LOGIN_PAGE'
export const SET_POST_LOGIN_SECTION = 'SET_POST_LOGIN_SECTION'
export const SET_PRE_CHECKOUT_REGISTRATION = 'SET_PRE_CHECKOUT_REGISTRATION'
export const SET_PAGE_SCROLL_CANCELLER = 'SET_PAGE_SCROLL_CANCELLER'
export const SET_CHECKOUT_STATE = 'SET_CHECKOUT_STATE'
export const SHOW_RESET_PASSWORD = 'SHOW_RESET_PASSWORD'
export const SHOW_USER_VERIFICATION_PROMPT = 'SHOW_USER_VERIFICATION_PROMPT'
export const SHOW_GENERAL_ALERT_POPUP = 'SHOW_GENERAL_ALERT_POPUP'
export const HIDE_GLOBAL_TIMER = 'HIDE_GLOBAL_TIMER'
export const SHOW_ITEM_REMOVED_ON_TIMEOUT_ALERT = 'SHOW_ITEM_REMOVED_ON_TIMEOUT_ALERT'
export const SET_ITEM_TYPE_REMOVED_ON_TIMEOUT = 'SET_ITEM_TYPE_REMOVED_ON_TIMEOUT'
export const SET_ITEM_REMOVED_ON_TIMEOUT = 'SET_ITEM_REMOVED_ON_TIMEOUT'
export const UNSET_ITEM_REMOVED_ON_TIMEOUT = 'UNSET_ITEM_REMOVED_ON_TIMEOUT'
export const SET_EXPIRATION_TIME_BILLING_ERROR = 'SET_EXPIRATION_TIME_BILLING_ERROR'
export const SET_BILLING_TOTAL = 'SET_BILLING_TOTAL'
export const SET_BILLING_GUEST_EMAIL = 'SET_BILLING_GUEST_EMAIL'
